import { useVerifyCodeStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Modal } from '@shared/widgets';

export const ErrorLoginCodeModal = () => {
  const { error, clear } = useVerifyCodeStore();

  const { navigate } = useRouteHook();

  const closeHandler = () => {
    clear();
    navigate(RoutePaths.loginCode.onNavigate());
  };

  return (
    <Modal title='Master Key Error' isOpen={!!error} onClose={closeHandler}>
      <p className='max-md:text-[#4c4c4c80]'>
        If you are having problems receiving your Master Key authentication code please contact our customer services team on the number below:
      </p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-[#000]'>24-hour phone support:</p>
        <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={closeHandler}>
        Ok
      </Button>
    </Modal>
  );
};
